import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL;

class AuthService {
  constructor() {
    this.token = null; 
    // this.refreshToken = null;
    this.casCredentials = null;
  }

  // Initialize auth on app load
  async initialize() {
    try {

      
      // Step 1: Get CAS credentials from PHP
      const phpResponse = await axios.get('./remote-apis/get-oidc-session.php');

      if (!phpResponse.data.success) {
        throw new Error('CAS authentication failed');
      }
      window.console.log('CAS authentication successful:', phpResponse.data);
      // Store credentials for potential refresh
      this.casCredentials = {
        username: phpResponse.data.username,
        signature: phpResponse.data.signature
      };


      // Step 2: Exchange for JWT
      await this.fetchJWT();

      return true;
    } catch (error) {
      window.console.error('Auth initialization failed:', error);
      throw error;
    }
  }

  // Fetch JWT from Django backend
  async fetchJWT() {
    if (!this.casCredentials) {
      throw new Error('No CAS credentials available');
    }

    try {
  
      const response = await axios.post(
        `${API_URL}/api/cas-to-jwt/`,
        {},
        {
          headers: {
            'X-CAS-User': this.casCredentials.username,
            'X-CAS-Signature': this.casCredentials.signature,
          }
        }
      );

      if (response.data.ok) {
        this.token = response.data.access;
        // this.refreshToken = response.data.refresh;

        return this.token;
      }

      throw new Error('Failed to get JWT');
    } catch (error) {
      window.console.error('JWT fetch error:', error);
      throw error;
    }
  }


  async refreshToken() {

    
    // Re-fetch CAS credentials (in case they changed)
    const phpResponse = await axios.get('./remote-apis/get-oidc-session.php');
    
    if (!phpResponse.data.success) {
      throw new Error('CAS authentication failed');
    }

    this.casCredentials = {
      username: phpResponse.data.username,
      signature: phpResponse.data.signature
    };

    // Fetch new JWT
    return await this.fetchJWT();
  }

  // Get current token
  getAccessToken() {
    return this.token;
  }

  // Check if authenticated
  isAuthenticated() {
    return this.token !== null;
  }

  // Get CAS username
  getUsername() {
    return this.casCredentials?.username || null;
  }

  // Logout
  logout() {
    this.token = null;
    this.casCredentials = null;

  }
}

export default new AuthService();